export default __webpack_public_path__ + "static/media/2024_Miki_and_Ke_2024_JournalTheoreticalBiology.647ea074.pdf";